import React, {useContext, useEffect, useState, useLayoutEffect} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import SelectTabContextProvider from '../../../../components/SelectTabContext/SelectTabContext';
import IconButton from '@material-ui/core/IconButton';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Tooltip from '@material-ui/core/Tooltip';
import ArrowLeftIcon from '@material-ui/icons/ArrowLeft';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import {ThemeContext} from '../../../../themes/ThemeProvider';
const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    listStyle: 'none',
    margin: 0,
  },
  headings: {
    width: '100%',
    padding: '0 0 5px 10px',
  },
  closeButton: {
    'color': '#000',
    'width': 17,
    'height': 17,
    'fontSize': 14,
    'padding': 2,
    'borderRadius': '50%',
    'margin': '0px 5px 0px 0px',
    'backgroundColor': '#FFFFFF',
    '&:hover, &:focus, &.active': {
      backgroundColor: '#FFFFFF',
      color: '#000',
      outline: 'none',
    },
    [theme.breakpoints.down('sm')]: {width: 12, height: 12},
  },
  iconButton: {
    padding: 8,
    [theme.breakpoints.down('md')]: {padding: 5},
  },
  formControl: {
    minWidth: 120,
  },
}));
const fixedTabs = [];

export default function DetailChips({
  tab,
  setTab,
  setLabel,
  label,
  newWindow,
  setNewWindow,
  selected,
  setSelected,
}) {
  const {
    selectedCMTabs,
    setSelectedCMTabs,
    setCurrentLabel,
    setOnChipClick,
    currentPage,
    setCurrentPage,
  } = useContext(SelectTabContextProvider);
  const {showWidgetSection} = useContext(ThemeContext);
  const classes = useStyles();
  const [chipData, setChipData] = useState([]);
  const [expanded, setExpanded] = useState([]);
  const [size, setSize] = useState([0, 0]);
  const handleRemove = ({label, code}) => {
    const filteredWindows = chipData.filter((chip) => chip.code !== code);

    setSelectedCMTabs(filteredWindows ? filteredWindows : null);
    const availableTabs = filteredWindows.map((item) => item.label);

    if (filteredWindows && filteredWindows.length > 0) {
      setLabel([...availableTabs]);
    } else {
      setLabel('');
    }
    setChipData(filteredWindows);
    setTab(tab - 1);
  };
  const handleExpansion = () => {
    setExpanded(!expanded);
  };
  const handleTab = (index, selectedLabel) => {
    setCurrentLabel(selectedLabel);
    setOnChipClick(true);
    setTab(index);
    setLabel([...label]);
  };
  const goToPreviousPage = () => {
    setCurrentPage((page) => page - 1);
  };

  const goToNextPage = () => {
    setCurrentPage((page) => page + 1);
  };
  useEffect(() => {
    setCurrentLabel('');
    setOnChipClick(false);
    if (selectedCMTabs.length > 0) {
      // may require for filter below  return Object.keys(roleData?.window?.["Client Maintenance"])?.includes(each.code);
      const data = [...fixedTabs, ...selectedCMTabs];
      const uniqData = [...new Set(data)];

      setChipData(uniqData);
      const availableWindows = uniqData.map((item) => item.label);

      if (uniqData && uniqData.length) {
        availableWindows.indexOf(uniqData[uniqData.length - 1].label) === -1 ?
          setLabel([...label, uniqData[uniqData.length - 1].label]) :
          setLabel([...availableWindows]);
      }
    } else if (selectedCMTabs.length === 0) {
      setCurrentLabel('');
      setOnChipClick(false);
      setChipData([]);
      setLabel([]);
    }
  }, [selectedCMTabs]);
  const arr = [...chipData];
  useEffect(() => {
    if (chipData?.length === 1) {
      setCurrentPage(1);
    }
  }, [chipData]);
  const useWindowSize = () => {
    useLayoutEffect(() => {
      function updateSize() {
        setSize([window.innerWidth, window.innerHeight]);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size[0];
  };
  const size1 = useWindowSize();
  const dataLimit =
    showWidgetSection || (size1 > 0 && size1 < 1536) ? 4 : expanded ? arr.length : 6;
  const pages = Math.ceil(chipData.length / dataLimit);
  const getPaginationGroup = (chipData = []) => {
    const arr = [...chipData];
    if (expanded) {
      return arr;
    } else {
      const startIndex = currentPage * dataLimit - dataLimit;
      const endIndex = startIndex + dataLimit;
      return arr.slice(startIndex, endIndex);
    }
  };
  return (
    <>
      <div className="col-md-12 account-sticky windows-sticky">
        <div className="row align-items-center justify-content-between">
          <div className="chips-wrapper">
            <div className="d-flex align-items-center justify-content-between">
              {/* <div className="col-md-12"> */}
              {!expanded && (
                <div className="col direction-icon">
                  <IconButton
                    aria-label="previous"
                    className={`${classes.iconButton} cursor-pointer`}
                    disabled={currentPage === 1}
                    onClick={goToPreviousPage}
                  >
                    <Tooltip title="Previous">
                      <ArrowLeftIcon style={{fontSize: 40}} />
                    </Tooltip>
                  </IconButton>
                </div>
              )}
              <div className={expanded ? 'col-md-11' : 'col-md-9 col-lg-10 p-0'}>
                {getPaginationGroup(chipData).map((data, index) => {
                  return (
                    <span key={data.label}>
                      <Chip
                        className={
                          (Array.isArray(label) && label.indexOf(data.label) >= 0) ||
                          data.label === label ?
                            'chip chip-active' :
                            'chip-default chip'
                        }
                        label={data.label}
                        onClick={() => handleTab(index, data.label)}
                        deleteIcon={<CloseIcon className={classes.closeButton} />}
                        onDelete={data.hideDeleteIcon ? null : () => handleRemove(data)}
                      />
                    </span>
                  );
                })}
              </div>
              {!expanded && (
                <div className="col direction-icon text-right">
                  <IconButton
                    aria-label="next"
                    edge="start"
                    disabled={currentPage === pages}
                    onClick={goToNextPage}
                    className={`${classes.iconButton} cursor-pointer`}
                  >
                    <Tooltip title="Next">
                      <ArrowRightIcon style={{fontSize: 40}} />
                    </Tooltip>
                  </IconButton>
                </div>
              )}
              <div className="col direction-icon text-right">
                <IconButton
                  aria-label="minmax"
                  edge="start"
                  onClick={handleExpansion}
                  className={`${classes.iconButton} cursor-pointer`}
                >
                  <Tooltip title="Next">
                    <ArrowForwardIosIcon
                      style={{fontSize: 15}}
                      className={expanded && 'icon-rotate'}
                    />
                  </Tooltip>
                </IconButton>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
